module.exports = {
      id: "ic-momentum-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-momentum-usage",
      toString: function () {
        return this.url;
      }
    }